export default __webpack_public_path__ + "static/media/alba-festival-history-2021.b4102fb7.jpg";